import React, {MutableRefObject, useRef, useState} from "react"
import classes from "./TransitionContainer.module.scss"

interface IBlock {
  title: string
  block: any
}

interface ITransitionContainerProps {
  blocks: IBlock[]
  className?: string
  classNameTitle?: string,
  currentTab?: number,
  classNameTitlesWrap?: string
  withTitleBorder?: boolean
  classNameBody?: string
}

function TransitionContainer({
                               blocks,
                               currentTab = 0,
                               className,
                               classNameTitle,
                               classNameTitlesWrap,
                               withTitleBorder,
                               classNameBody
                             }: ITransitionContainerProps) {

  const currentTitle: MutableRefObject<any> = useRef();
  const [activeTab, setActiveTab] = useState(currentTab)
  const [currentBody, setCurrentBody] = useState(blocks[activeTab].block)

  const cls = [classes.wrap]
  if (className) cls.push(className)

  const clsTitle = [classes.title]
  if (classNameTitle) clsTitle.push(classNameTitle)

  const clsTitlesWrap = [
    classes.header,
    withTitleBorder ? classes.header_border : undefined,
  ];

  if (classNameTitlesWrap) clsTitlesWrap.push(classNameTitlesWrap);

  const clsBody = [classes.body];
  if (classNameBody) clsBody.push(classNameBody);

  function slideBlock(event: any, id: number) {
    setActiveTab(id);
    currentTitle.current.classList.remove(classes.title_active);
    setCurrentBody(blocks[id].block);
    currentTitle.current = event.target;
    currentTitle.current.classList.add(classes.title_active);
  }

  const templateBlocksTitle = blocks.map((elem, id) => {
    const className = [...clsTitle];

    if (activeTab === id) {
      className.push(classes.title_active);
    }
    return (
      <div
        className={className.join(' ')}
        key={id}
        ref={currentTitle}
        onClick={(event) => slideBlock(event, id)}
      >
        {elem.title}
      </div>
    );
  });

  return (
    <div className={cls.join(" ")}>
      <div className={clsTitlesWrap.join(' ')}>{templateBlocksTitle}</div>
      <div className={clsBody.join(' ')}>{currentBody}</div>
    </div>
  )
}

export default TransitionContainer